<template>
  <div class="fm-style">
    <el-form
      ref="generateForm"
      :disabled="readonly"
      :rules="rules"
      label-suffix=":"
      :size="data.config.size"
      :model="models" :label-position="data.config.labelPosition" :label-width="data.config.labelWidth + 'px'"
    >
      <template v-for="item in data.list">
        <template v-if="item.type == 'grid'">
          <el-form-item
            :key="item.key" :label="item.options.showName ? item.name : ''"
            :label-width="!item.options.showName ? '0px' : null"
          >
            <el-row
              :key="item.key"
              type="flex"
              :gutter="item.options.gutter ? item.options.gutter : 0"
              :justify="item.options.justify"
              :align="item.options.align"
            >
              <el-col v-for="(col, colIndex) in item.columns" :key="colIndex" :span="col.span">
                <template v-for="citem in col.list">
                  <el-form-item v-if="citem.type=='blank'" :key="citem.key" :label="citem.name" :prop="citem.model">
                    <slot :name="citem.model" :model="models" />
                  </el-form-item>
                  <genetate-form-item
                    v-else
                    :key="citem.key + citem.timer"
                    :models.sync="models"
                    :remote="remote"
                    :rules="rules"
                    :widget="citem"
                    @input-change="onInputChange"
                  />
                </template>
              </el-col>
            </el-row>
          </el-form-item>
        </template>
        <template v-else-if="item.type === 'linkquery'">
          <div :key="timer" class="widget-col widget-view my-2" style="min-height: 40px;">
            <div v-if="item.options.showName" class="mb-2">{{ item.name }}</div>
            <template v-if="!item.options.multi">
              <template v-for="(_item, _index) in item.options.linkFields">
                <el-form-item v-if="_item.visible" :key="_index">
                  <span slot="label">
                    {{ _item.text }}
                  </span>
                  {{
                    getLinkFieldData(item.key + '.' + _item.name)
                  }}
                </el-form-item>
              </template>
            </template>
            <template v-else>
              <div class="link-query-table">
                <el-table v-fit-columns :data="tableData" border>
                  <el-table-column
                    v-for="(_item, _index) in item.options.linkFields" :key="_index" :prop="_item.name" :label="_item.text"
                  />
                </el-table>
              </div>
            </template>
          </div>
        </template>

        <template v-else-if="item.type == 'blank'">
          <el-form-item :key="item.key" :label="item.name" :prop="item.model">
            <slot :name="item.model" :model="models" />
          </el-form-item>
        </template>

        <template v-else>
          <genetate-form-item
            :key="item.key + item.timer"
            :models.sync="models"
            :rules="rules"
            :widget="item"
            :remote="remote"
            :auth-member="authMember"
            @input-change="onInputChange"
          />
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
import GenetateFormItem from './GenerateFormItem'
import axios from 'axios'
import zroute from '../../ziggy'
import {debounce} from 'lodash/function'
import _ from 'lodash'

export default {
  name: 'FmGenerateForm',
  components: {
    GenetateFormItem,
  },
  props: ['data', 'remote', 'value', 'insite', 'authMember', 'readonly'],
  data() {
    return {
      tableData: [],
      models: {},
      rules: {},
      link_filter_fields: {},
      link_datas: {},
      timer: Date.now(),
      link_queries: [],//保存当前表单关联查询的数据
      default_links: [],//默认值数据关联
    }
  },
  watch: {
    rules: {
      deep: true,
      handler(val) {
        console.log('rules', val)

      },
    },
    data: {
      deep: true,
      handler(val) {
        // this.generateModle(val.list)

      },
    },
    value: {
      deep: true,
      handler(val) {
        console.log(JSON.stringify(val))
        this.models = val
        this.generateModle(this.data.list)
        console.log('models', this.models)
      },
    },
    models: {
      deep: true,
      handler(val) {
        console.log('models', val)
      },
    },
  },
  created() {
    console.log('GenerateForm created', this.data)
    this.generateModle(this.data.list)
    // this.handlerLinkQuery()
    // this.handlerFieldShowRules()
  },
  mounted() {
  },
  methods: {
    getLinkFieldData(path) {
      return _.get(this.link_datas, path, '')
    },
    handlerLinkQueryShow(data, item) {
      if (item.multi) {
        console.log('handlerLinkQueryShow', item)
        this.tableData = data
      } else {
        this.link_datas[item.formWidgetId] = data[0]
        for (let field in this.link_datas[item.formWidgetId]) {
          this.$set(this.models, field, this.link_datas[item.formWidgetId][field])
          this.handlerFieldShowRules(field)
        }
        console.log('this.models', this.models)
        this.timer = Date.now()
      }

    },
    //处理关联查询数据显示
    handlerLinkQuery(changeField) {
      // this.$watch( function () {
      //   return {
      //     input_1654593817000_90399: this.models['input_1654593817000_90399'],
      //     input_1654593819000_59016: this.models['input_1654593819000_59016'],
      //   }
      // }, function (newVal, oldVal) {
      //   console.log('input_1654593817000_90399,input_1654593819000_59016', newVal, oldVal)
      // })
      // if (Object.keys(this.link_filter_fields).indexOf(field) >= 0) {
      //   var item = _.cloneDeep(this.link_filter_fields[field])
      //   //更新值
      //   item.filter.find(item => item.rely === field).value = value ? value : ''
      //   this.filterLink(item)
      // }
      this.data.list.forEach(item => {
        if (item.type === 'linkquery') {
          if (item.options.linkFilter.filter(_field => _field.rely === changeField).length === 0) {
            return
          }
          console.log('handlerLinkQuery', item, this.models)

          // this.filterLink(item)
          // let query = {
          //   fields: genList[i].options.linkFields.map(item => item.name),
          //   filter: genList[i].options.linkFilter,
          //   formId: genList[i].options.linkForm,
          //   formWidgetId: genList[i].key,
          // }
          this.filterLink({
            multi: item.options.multi,
            fields: item.options.linkFields.map(_field => _field.name),
            filter: item.options.linkFilter.map(_filter => {
              if (_filter.rely === changeField) {
                _filter.value = this.models[changeField] ? this.models[changeField] : ''
              }
              return _filter
            }),
            formId: item.options.linkForm,
            formWidgetId: item.key,
          })
        }
      })
    },
    //显隐规则
    handlerFieldShowRules(changeField) {
      console.log('handlerFieldShowRules', changeField)
      if (!Object.keys(this.data.config).includes('fieldShowRules')) {
        return
      }
      // console.log('handlerFieldShowRules', this.data.config.fieldShowRules, changeField)

      this.data.config.fieldShowRules.forEach(item => {
        if (item.filter.cond.filter(_field => _field.field === changeField).length === 0) {
          return
        }
        // console.log('handlerFieldShowRules', item, this.models)
        let _results = item.filter.cond.map(cond => {
          return this.models[cond.field] == cond.value[0] && cond.method === 'eq'
        })
        console.log('handlerFieldShowRules forEach', item, this.models, _results)
        if (_results.length === 0) {
          return
        }
        this.data.list.filter(_data => item.fields.includes(_data.key)).map(_data => {
          _data.options.visible = (item.filter.rel === 'or' && _results.includes(true)) || (item.filter.rel === 'and' && !_results.includes(false))
        })
      })
    },
    handleItemDefaultValue(item, changeField) {
      if (item.options.defaultValueType === 1) {//公式
        let formula = _.get(item.options.rely, 'formula.formula', '')
        if (formula.indexOf('$' + changeField + '#') >= 0) {
          var temp = []
          formula.split(new RegExp('(\\$[0-9a-zA-Z._#@]+)', 'g')).map((sub_item, sub_index) => {
            if (/^\$(_?[a-z]+_[0-9]{13}|[0-9]{13}_[0-9]+)/.test(sub_item)) {
              var field = (sub_item.replace('$', '').split('#'))[0]
              temp.push(this.models[field])
            } else {
              temp.push(sub_item)
            }
          })
          console.log('temp', temp)
          // formula.replace('$' + changeField + '#', this.models[changeField])
          try {
            if (temp[0] === 'CONTACT(') {
              this.models[item.model] = temp[1] + temp[3]
            } else {
              this.models[item.model] = eval(temp.join(''))

            }
          } catch (e) {
            console.log('error', e)
          }
          item.timer = Date.now()
        }
      } else if (item.options.defaultValueType === 2) {//数据关联
        // if (item.options.rely) {
        //   console.log('handleDefaultValue', item.options.rely, this.default_links)
        //
        // }
      }
    },
    //处理默认值中的数据关联和公式编辑
    handleDefaultValue(changeField) {
      //todo 公式调整为不遍历所有字段
      this.data.list.forEach(item => {
        if (item.type === 'grid') {
          console.log(item)
          item.columns.forEach(_column => {
            _column.list.forEach(_item => {
              this.handleItemDefaultValue(_item, changeField)
            })
          })
        } else {
          this.handleItemDefaultValue(item, changeField)
        }

      })
      console.log('handleDefaultValue', changeField, this.default_links)
      //如果更新的字段是数据联动条件中的字段，则更新数据联动条件中的值
      this.default_links.forEach(item => {
        var _filter = item.filter.cond.filter(_field => _field.depend_field === changeField)
        if (_filter.length === 0) {
          return
        }
        _filter.map(_field => {
          _field.value = this.models[changeField]
        })
        this.handlerLink(item)
      })
    },
    generateModle(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === 'grid') {
          genList[i].columns.forEach(item => {
            this.generateModle(item.list)
          })
        } else {
          if (genList[i].type === 'user') {
            if (genList[i].options.defaultValue) {
              this.models[genList[i].model] = 'user_' + this.authMember.member.id
            } else {
              this.models[genList[i].model] = ''
            }
          } else if (genList[i].type === 'dept') {
            console.log('dept', genList[i], this.models)

            if (genList[i].options.defaultValue === 'dynamic_current_dept') {
              this.models[genList[i].model] = Object.keys(this.authMember.dept_list).length > 0 ? 'department_' + this.authMember.dept_list.id : ''
              console.log('dept2', genList[i], this.models)

            } else if (genList[i].options.defaultValue === 'dynamic_current_parent_dept') {
              this.models[genList[i].model] = Object.keys(this.authMember.parent_dept_list).length > 0 ? 'department_' + this.authMember.parent_dept_list.id : ''
            } else {
              this.models[genList[i].model] = ''
            }
          } else if (genList[i].type === 'linkquery') {
          } else {
            if (this.value && Object.keys(this.value).indexOf(genList[i].model) >= 0) {
              this.models[genList[i].model] = this.value[genList[i].model]
            } else {
              if (genList[i].type === 'blank') {
                this.$set(this.models, genList[i].model, genList[i].options.defaultType === 'String' ? '' : (genList[i].options.defaultType === 'Object' ? {} : []))
              } else {
                this.models[genList[i].model] = genList[i].options.defaultValue
              }
            }
            if (genList[i].options.defaultValueType === 2 && genList[i].options.rely) {
              //相同条件的联动放入同一个数组中
              //条件key为formId+formWidgetId+filterId+filterMethod+filterValue
              let rely = genList[i].options.rely

              var d_link = this.default_links.find(item => {
                if (item.formId !== rely.data.formId) {
                  return false
                }
                if (item.filter.rel !== rely.filter.rel) {
                  return false
                }
                if (_.xor(item.filter.cond.map(cond => cond.field), rely.filter.cond.map(cond => cond.field)).length > 0) {
                  return false
                }
                //todo
                return true
              })
              if (!d_link) {
                var _fields = {}
                _fields[genList[i].model] = rely.data.field
                d_link = {
                  formType: rely.data.formType,
                  formId: rely.data.formId,
                  fields: _fields,
                  filter: rely.filter,
                }
                this.default_links.push(d_link)
              } else {
                d_link.fields[genList[i].model] = rely.data.field
              }
            }
          }


          if (this.rules[genList[i].model]) {

            this.rules[genList[i].model] = [...this.rules[genList[i].model], ...genList[i].rules.map(item => {
              if (item.pattern) {
                return {...item, pattern: new RegExp(item.pattern)}
              } else {
                return {...item}
              }
            })]
          } else {
            this.rules[genList[i].model] = [...genList[i].rules.map(item => {
              if (item.pattern) {
                return {...item, pattern: new RegExp(item.pattern)}
              } else {
                return {...item}
              }
            })]
          }
          // console.log('rules', this.rules)
        }
      }
    },
    getData() {
      console.log('getData', this.rules)
      return new Promise((resolve, reject) => {
        this.$refs.generateForm.validate(valid => {
          if (valid) {
            resolve(this.models)
          } else {
            reject(new Error(this.$t('fm.message.validError')).message)
          }
        })
      })
    },
    reset() {
      this.$refs.generateForm.resetFields()
    },
    onInputChange(value, field) {
      // console.log('onInputChange', value, field)
      // if (Object.keys(this.link_filter_fields).indexOf(field) >= 0) {
      //   var item = _.cloneDeep(this.link_filter_fields[field])
      //   //更新值
      //   item.filter.find(item => item.rely === field).value = value ? value : ''
      //   this.filterLink(item)
      // }
      this.handlerLinkQuery(field)
      this.handlerFieldShowRules(field)
      this.handleDefaultValue(field)
      this.$emit('on-change', field, value, this.models)
    },
    refresh() {

    },
    handlerLink(item) {
      axios.post(zroute('app.data.link'), {...item, appId: zroute().params.app_id, entryId: zroute().params.form_id}).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          this.models[item.model] = res.data.data
        }
        for (let _field in res.data.data) {
          this.models[_field] = res.data.data[_field]
        }
      })
    },
    filterLink: debounce(function (item) {
      console.log('filterLink', item)
      axios.post(zroute('app.data.filter_link'), {...item, appId: zroute().params.app_id}).then(res => {
        console.log(res)
        this.handlerLinkQueryShow(res.data.data.dataList, item)
      })
    }, 200),
  },
}
</script>

<style lang="scss" scoped>
.link-query-table {
}
// @import '../styles/cover.scss';
</style>
